import React from "react";
import instagramIcon from "../assets/footer/instagram.svg";
import linkedinIcon from "../assets/footer/linkedin.svg";
import footerEllipse from "../assets/footer/footer-ellipse.svg";
import Logo from "../assets/icons/Logo";
import CustomButton from "./CustomButton";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="relative mt-12 md:mt-0 text-white">
      <img
        src={footerEllipse}
        alt=""
        aria-hidden
        className="pointer-events-none absolute left-1/2 -z-[1] -translate-x-1/2 bottom-0 md:w-full w-screen max-w-none"
      />
      <div className="relative z-10 w-full px-6 md:px-16 pb-8 grid gap-10 md:gap-10 md:grid-cols-[1.5fr,1fr,1fr,1.8fr]">
        <div className="text-center md:text-left order-2 md:order-none">
          <h4 className="font-bold text-lg mb-2">CONTACT</h4>
          <ul className="flex flex-col gap-1">
            <li className="font-light">
              <CustomButton
                variant="link"
                to="/contact-us"
                className="whitespace-normal text-left hover:underline"
                aria-label="pricing"
              >
                info@drospect.ai
              </CustomButton>
            </li>
            <li className="font-light">
              <p aria-label="our adress">Messitytönkatu 8, Helsinki 00180</p>
            </li>
          </ul>
        </div>
        <div className="hidden md:block text-center md:text-left">
          <h4 className="font-bold text-lg mb-2" aria-label="links">
            LINKS
          </h4>
          <ul className="flex flex-col gap-1">
            <li className="font-light">
              <CustomButton
                variant="link"
                to="/pricing"
                className="whitespace-normal text-left hover:underline"
                aria-label="pricing"
              >
                Pricing
              </CustomButton>
            </li>
            <li className="font-light">
              <CustomButton
                variant="link"
                to="/solutions"
                className="whitespace-normal text-left hover:underline"
                aria-label="solutions"
              >
                Solutions
              </CustomButton>
            </li>
            <li className="font-light">
              <CustomButton
                variant="link"
                to="/contact-us"
                className="whitespace-normal text-left hover:underline"
                aria-label="contact us"
              >
                Contact us
              </CustomButton>
            </li>
            <li className="font-light">
              <CustomButton
                variant="link"
                to="https://www.linkedin.com/company/drospect/jobs/"
                target="_blank"
                className="whitespace-normal text-left hover:underline"
                aria-label="career"
              >
                Careers
              </CustomButton>
            </li>
          </ul>
        </div>
        <div className="text-center md:text-left order-1 md:order-none">
          <h4 className="font-bold text-lg mb-2">
            <Link to={"/solutions"} className="hover:underline">
              SOLUTIONS
            </Link>
          </h4>
          <ul className="flex flex-col gap-1">
            <li className="font-light">
              <Link
                to={"/solutions/thermal-orthomosaic"}
                className="hover:underline"
              >
                AI-Generated Thermal Orthomosaic Digital Twin
              </Link>
            </li>
            <li className="font-light">
              <Link
                to={"/solutions/defect-hotspot-detection"}
                className="hover:underline"
              >
                Automated Solar Panel Defect & Hotspot Detection
              </Link>
            </li>
            <li className="font-light">
              <Link
                to={"/solutions/performance-screening"}
                className="hover:underline"
              >
                RGB & Satellite-Based Performance Screening
              </Link>
            </li>
            <li className="font-light">
              <Link
                to={"/solutions/data-integration"}
                className="hover:underline"
              >
                Custom API & Asset Management Integration
              </Link>
            </li>
          </ul>
        </div>
        <div className="space-y-4 order-last md:order-first flex flex-col items-center md:items-start text-center md:text-left">
          <div className="w-full flex items-center justify-center gap-6 md:w-auto md:flex-col md:items-start md:justify-start md:gap-4">
            <Logo width="150" height="40" />
            <div className="flex justify-end gap-4 md:justify-start">
              <CustomButton
                href="https://www.linkedin.com/company/drospect/?viewAsMember=true"
                target="_blank"
                variant="link"
                aria-label="Follow us on Linkedin"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="Linkedin" />
              </CustomButton>
              <CustomButton
                href="https://www.instagram.com/the.drospect/"
                target="_blank"
                variant="link"
                aria-label="Follow us on Instagram"
                rel="noopener noreferrer"
              >
                <img src={instagramIcon} alt="Instagram" />
              </CustomButton>
            </div>
          </div>
          <p className="text-white/70">
            &copy; {new Date().getFullYear()} - Drospect. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
